import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid gap-3 text-sm" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";

export type BenefitItem = {
	iconName: string;
	title: string;
	description: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BenefitItems',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `item-${i}`,
        class: "flex"
      }, [
        (item.iconName)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              "icon-name": item.iconName,
              class: "mr-3 h-8 w-8 shrink-0"
            }, null, 8, ["icon-name"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("b", _hoisted_2, _toDisplayString(item.title), 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(item.description), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})